import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CompanyList from "../pages/company-list/page";
import SellPage from "../pages/sell/page";
import BuyPage from "../pages/buy/page";
import MAListPage from "../pages/ma-list/page";
import ContactPage from "../pages/contact/page";
import CasesPage from "../pages/cases/page";
import AboutPage from "../pages/about/page";
import PrivacyPage from "../pages/privacy/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/company-list",
    element: <CompanyList />,
  },
  {
    path: "/sell",
    element: <SellPage />,
  },
  {
    path: "/buy",
    element: <BuyPage />,
  },
  {
    path: "/active-company-transfer",
    element: <MAListPage />,
  },
  {
    path: "/cases",
    element: <CasesPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/privacy",
    element: <PrivacyPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
